import type { ReactNode } from 'react'

import { cn } from '@/utils'

export const CELL_CLASS = 'px-3 py-[11px] align-baseline'

// A main line with a small grey line under it, like "E*TRADE •• 6460" over "Investment".
export const TwoLineCell = ({
  main,
  sub,
  className,
}: {
  main: ReactNode
  sub?: ReactNode
  className?: string
}) => (
  <td className={cn(CELL_CLASS, 'whitespace-normal', className)}>
    <span className="block truncate">{main}</span>
    {sub && <span className="mt-px block text-xs text-ink-subtle">{sub}</span>}
  </td>
)

export const FigureCell = ({
  children,
  quiet = false,
  colSpan,
}: {
  children: ReactNode
  quiet?: boolean
  colSpan?: number
}) => (
  <td
    colSpan={colSpan}
    className={cn(
      CELL_CLASS,
      'whitespace-nowrap text-right tabular-nums',
      quiet && 'text-ink-subtle',
    )}
  >
    {children}
  </td>
)
